// mbb-dash/config/config.js

// Base Worker URL (set via Vite environment variables)
const WORKER_URL = import.meta.env.VITE_WORKER_URL;

const config = {
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // Worker URL builder
  buildApiUrl(endpoint) {
    const cleanEndpoint = endpoint.replace(/^\//, "");
    return `${WORKER_URL}/api/${cleanEndpoint}`;
  },

  // Get auth header from localStorage
  getAuthHeader() {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      console.warn("No auth_token found in localStorage");
      return null;
    }
    return `Bearer ${token}`; // Use Bearer token
  },

  // Store token in localStorage
  setAuthToken(token) {
    if (token) localStorage.setItem("auth_token", token);
  },

  // Remove token
  clearAuthToken() {
    localStorage.removeItem("auth_token");
  },
};

export default config;
